import { Injectable, ComponentRef } from '@angular/core';

@Injectable()
export class ModalService {
  private modal: ComponentRef<any>;

  constructor() { }

  isModalDefined(): boolean {
    return this.modal !== undefined ? true : false;
  }

  setModal(modalComponentRef: ComponentRef<any>): void {
    this.modal = modalComponentRef;
  }

  closeModal(): void {
    if (this.modal) {
      this.modal.instance.onClickedExit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/modal.service.ts